export default __webpack_public_path__ + "static/media/pd3.985031e6.jpg";